<template>
  <div class="newsdetail">
    <Breadcrumb separator=">">
      <BreadcrumbItem to="/message/news">{{$t('title.w40')}}</BreadcrumbItem>
      <BreadcrumbItem>{{$t('title.w41')}}</BreadcrumbItem>
    </Breadcrumb>
    <div class="new-content">
      <h3 class="h3">{{title}}</h3>
      <p class="desc"><i class="icon"></i> <span class="mar-r30">{{CreatedAt}}</span> <span>{{$t('other.w81')}}</span></p>
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content:'',
      title:'',
      CreatedAt:''
    }
  },
  created(){
    this.$axios.get("/Member/RZJInfoCenter/InformationDetail", {
        params: {
          informationId: this.$route.query.id
        }
      })
      .then(res => {
        if (res.err){
          res.throw()
          this.$router.replace({name:'news'})
          return;
        }
        this.content = res.Content;
        this.title = res.Subject;
        this.CreatedAt = res.CreatedAt;
      });
  }
};
</script>

<style lang="less" scoped>
.newsdetail{
  width: 1200px;
  min-height: 600px;
  .new-content{
    width: 800px;
    margin: 0 auto;
    color: #232325;
    .mar-r30{
      margin-right: 30px;
    }
    .h3{
      font-size: 24px;
      font-weight: 500;
      margin:40px 0 20px;
    }
    .desc{
      color: #7B7B7C;
      display: flex;
      align-items: center;
      margin-bottom: 50px;
      .icon{
        display: inline-block;
        width: 12px;
        height: 12px;
        background: url("../../assets/assetcenter/news_times.png") no-repeat;
        background-size: cover;
        margin-right: 5px;
      }

    }
  }
}
</style>
